import { BaseUrl } from '@/helpers/BaseUrl'
import adminAxios from '@/plugins/axios'
import { defineStore } from 'pinia'

const exportUrl = BaseUrl.get('export')

export const useExportStore = defineStore('export', {
  state: () => {
    return {}
  },
  getters: {},
  actions: {
    async downloadDoc(id) {
      try {
        return await adminAxios.get(`${exportUrl}/download?id=${id}`, {
          responseType: 'blob',
        })
      } catch (error) {
        return await Promise.reject(error)
      }
    },
    async getExportableAttributes(exportModel, filter) {
      const params = {}
      if (filter) {
        params.filter = filter
      }
      params.model = exportModel
      try {
        return await adminAxios.get(`${exportUrl}/attributes`, { params })
      } catch (error) {
        return await Promise.reject(error)
      }
    },
    async export(exportModel, attributes, dataObject = {}, filter = null) {
      const body = {
        model: exportModel,
        attributes,
        filter,
        ...dataObject,
      }

      try {
        return await adminAxios.post(`${exportUrl}`, body)
      } catch (error) {
        return await Promise.reject(error)
      }
    },
  },
})
